import { IState } from '../../../store';

export const selectExternalTour = (state: IState): string | null => {
  return state.offerData.tours?.externalTour?.tourUrl || null;
};
